import { render } from "./SelectShapes.vue?vue&type=template&id=33038514"
import script from "./SelectShapes.vue?vue&type=script&lang=js"
export * from "./SelectShapes.vue?vue&type=script&lang=js"

import "./SelectShapes.vue?vue&type=style&index=0&id=33038514&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__